import { Component, OnInit, TemplateRef, ViewChild ,Input} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../_service/message-service';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/_services/user.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { Permission } from 'src/app/util/enums/permission.enum';
import { AuthenticationService } from 'src/app/_services';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';


@Component({
  selector: 'telio-rfid-all',
  templateUrl: './rfid-all.component.html',
  styleUrls: ['./rfid-all.component.scss']
})
export class RfidAllComponent implements OnInit  {
  @Input() actionFeatureFlag = false;
  allRfids;
  currentuser;
  userid;
  desplayRfid;
  disableEdit: boolean = false;
  disableAssign: boolean = false;
  disbleDelete: boolean = false;
  deleteId;
  userDetails:any;
  actionFeatureLabel: string = 'rfid.createTitle';
  columns: TableColumn[];
  buttons: TableBtn[];
  rfidConsolidatedList: RFIDConsolidatedList[];
  subscription: Subscription = new Subscription;
  sortColumn = '';
  sortDirection = 'asc';
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  rfidTag;
  currentPage = 0;
  totalDataCount = 0;
  actionHeader: string = '';
  filterPlaceholder: string = '';
  @ViewChild('viewRfidDetails', { static: false }) viewRfidDetails: TemplateRef<any>; 
  @ViewChild('viewUserDetails', { static: false }) viewUserDetails: TemplateRef<any>;
  constructor(private router: Router,
    private rfidService: RfidServiceService,
    public loaderService: LoaderService,readonly breadcrumbService: BreadcrumbService,
    private userInfoService: UserInfoService,
    private toastr: SnackbarService,
    public translate: TranslateService,
    private userService: UserService,
    readonly route: ActivatedRoute,
    private authenticationService:AuthenticationService,
    readonly dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.columns = [
      { columnDef: 'idTag', header: 'rfid.rfidTag', cell: (element: RFIDConsolidatedList) => `${element.rfidTag}`, sortingDisabled: false, width: 'auto', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'status', header: 'rfid.status', cell: (element: RFIDConsolidatedList) => `${element.status}`, sortingDisabled: false, width: 'auto', caseSensitive: 'uppercase'},
      { columnDef: 'createdBy', header: 'rfid.createdBy', cell: (element: RFIDConsolidatedList) => `${element.createdBy}`, sortingDisabled: true, width: '120px', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'owner', header: 'rfid.owner', cell: (element: RFIDConsolidatedList) => `${element.role}`, sortingDisabled: false, width: 'auto' },
    ];


    this.buttons = [
      { styleClass: 'submit', icon: 'add', payload: (element: RFIDConsolidatedList) => `${element.rfidTag}`, action: 'block', tooltip: 'rfid.assign', isDisabled: (element: RFIDConsolidatedList) => `${element.disableAssign}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE), hide: (element: RFIDConsolidatedList) => `${element.checkStatusRejected}` },
      { styleClass: 'submit', icon: 'edit', payload: (element: RFIDConsolidatedList) => `${element.rfidTag}`, action: 'edit', tooltip: 'rfid.edit', isDisabled: (element: RFIDConsolidatedList) => `${element.disableEdit}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE), hide: (element: RFIDConsolidatedList) => `${element.checkStatusRejected}` },
      { styleClass: 'submit', icon: 'delete', payload: (element: RFIDConsolidatedList) => `${element.rfidTag}`, action: 'delete', tooltip: 'rfid.discard', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.DELETE), hide: (element: RFIDConsolidatedList) => `${element.checkStatusRejected}` },
      { styleClass: 'submit', icon: 'add', payload: (element: RFIDConsolidatedList) => `${element.rfidTag}`, action: 'assign', tooltip: 'rfid.reactivate', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE), hide: (element: RFIDConsolidatedList) => `${!element.checkStatusRejected}` },
    ];

    this.actionHeader = 'actions';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);
    this.currentuser = this.userInfoService.userDetails;

    this.userid = this.currentuser.userId
    this.getRFIDs(this.pageList, '');
  }

  getRFIDs(value: any, searchFilter: string = '') {
    if (this.userInfoService.isAdminGroup() ) {
      this.getAllRfids(value, searchFilter);
    }
    else  {
      this.getRfidByCpo(value, searchFilter)
    }
  }

  getAllRfids(value: any, searchFilter: string = '') {
    this.subscription.add(this.rfidService.getAllRfids(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter)
      .subscribe((res: any) => {
        this.rfidConsolidatedList = res.content;
        this.totalDataCount = res.total_items;
        this.rfidConsolidatedList.map((item: any, i: number) => {
          let empty = 'NA';
          item.id = i;
          item.rfidTag = !item.id_tag ? empty : item.id_tag;
          item.createdBy = !item.created_by_name && !item.created_by_id ? empty : item.created_by_name + ' (' + item.created_by_id + ')';
          item.status = !item.status ? empty : item.status;
          item.role = !item.owner ? empty : item.owner;
          item.disableEdit = item.status.toLowerCase() == 'new' ? true : (item.status.toLowerCase() == 'pending for activation' || item.status.toLowerCase() == 'activated' || item.status.toLowerCase() == 'blocked') ? false : false;
          item.disableDelete = item.status.toLowerCase() == 'new' ? false : (item.status.toLowerCase() == 'pending for activation' || item.status.toLowerCase() == 'activated' || item.status.toLowerCase() == 'blocked') ? true : false;
          item.disableAssign = item.status.toLowerCase() == 'new' ? false : (item.status.toLowerCase() == 'pending for activation' || item.status.toLowerCase() == 'activated' || item.status.toLowerCase() == 'blocked') ? true : false;
          item.checkStatusRejected = item.status.toLowerCase() == 'rejected';
        });
      }, err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }));
  }

  getRfidByCpo(value: any, searchFilter: string = '') {
    this.subscription.add(this.rfidService.getAllRfids(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter)
      .subscribe((res: any) => {
        this.rfidConsolidatedList = res.content;
        this.totalDataCount = res.total_items;
        this.rfidConsolidatedList.map((item: any, i: number) => {
          let empty = 'NA';
          item.id = i;
          item.rfidTag = !item.id_tag ? empty : item.id_tag;
          item.createdBy = !item.created_by_name && !item.created_by_id ? empty : item.created_by_name + ' (' + item.created_by_id + ')';
          item.status = !item.status ? empty : item.status;
          item.role = !item.owner ? empty : item.owner;
          item.disableEdit = item.status.toLowerCase() == 'new' ? true : (item.status.toLowerCase() == 'pending for activation' || item.status.toLowerCase() == 'activated' || item.status.toLowerCase() == 'blocked') ? false : false;
          item.disableDelete = item.status.toLowerCase() == 'new' ? false : (item.status.toLowerCase() == 'pending for activation' || item.status.toLowerCase() == 'activated' || item.status.toLowerCase() == 'blocked') ? true : false;
          item.disableAssign = item.status.toLowerCase() == 'new' ? false : (item.status.toLowerCase() == 'pending for activation' || item.status.toLowerCase() == 'activated' || item.status.toLowerCase() == 'blocked') ? true : false;
          item.checkStatusRejected = item.status.toLowerCase() == 'rejected';
        });
      }, err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }));
  }

  rfidDetails(item) {
    this.rfidTag = item.id_tag;
      this.rfidService.getRfidDetailsById(this.authenticationService.convertToBase64(this.rfidTag)).subscribe(resp => {
      Object.keys(resp).map(x => {
        if (resp[x]) {
          (!resp[x] || resp[x] == '') ? resp[x] = 'NA' : null;
        }
      })
      this.desplayRfid = resp;
      let dialogRef = this.dialog.open(this.viewRfidDetails, {
        height: '500px',
        width: '800px'
      }).afterClosed().subscribe((res: any) => {
      })
    })
  }

  userDetailsRfid(item) {
    if(!!item.created_by_id){
      this.userService.getUserDetails(item.created_by_id).subscribe((resp: any) => {
        if (!!resp) {
          this.userDetails = resp.data;
          let empty = 'NA';
          let event = this.userDetails
          event.username = !event.username ? empty : event.username;
          event.email = !event.email ? empty : event.email;
          event.emailValidated = event.email_validated;
          event.mobile = !event.mobile ? empty : event.mobile;
          event.mobileValidated = event.mobile_validated;
          event.countryCode = !event.country_code ? '' : event.country_code;
          event.roles = (!event.roles && event.roles.length > 0) ? empty : event.roles[0].name;
          event.status = !event.status ? empty : event.status.toUpperCase();
          event.tenantId = !event.tenant_id ? empty : event.tenant_id;
          event.signupType = !event.signup_type ? empty : event.signup_type;
          event.prefLanguage = !event.pref_language ? empty : event.pref_language.toUpperCase();
          event.pancard = !event.pancard ? empty : event.pancard;
          event.gstNumber = !event.gst_number ? empty : event.gst_number;
          event.state = !event.state ? empty : event.state;
          event.vehicleRegNo = !event.vehicle_reg_no ? empty : event.vehicle_reg_no;

          let dialogRef = this.dialog.open(this.viewUserDetails, {
            height: '500px',
            width: '800px'
          }).afterClosed().subscribe((res: any) => {
          })
        } else {
          this.toastr.error(this.translate.instant('generalTable.noRecord'));
        }
      }, error => {
        this.toastr.error(this.translate.instant('generalTable.noRecord'));
      })

    }else{
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    }
     
  }

  assignRfid(item) {
    this.router.navigate(["/dashboard/rfid/assign", { routeID: this.route.snapshot.paramMap.get('routeID') }], { queryParams: { "rfidId": this.authenticationService.convertToBase64(item.id_tag) } });
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.RFID_ASSIGN);
  }

  editAssignedRfid(item) {
    this.router.navigate(["/dashboard/rfid/edit-assign", { routeID: this.route.snapshot.paramMap.get('routeID') }], { queryParams: { "rfidId": this.authenticationService.convertToBase64(item.id_tag) } });
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.RFID_EDIT);
  }

  deleteRfid(item) {
    this.deleteId = item.id_tag;
    this.deleteFeature();
  }

  deleteRfidById() {
    this.rfidService.deleteRfidCard(this.authenticationService.convertToBase64(this.deleteId)).subscribe((resp: any) => {
      if (resp != null) {
        this.toastr.success(resp.status_message);
        this.getRFIDs(this.pageList, '')
      }
      else {
        this.toastr.error(this.translate.instant('rfid.deleteFail'))
      }
    },
      error => {
        this.toastr.error(error);
      }
    )
  }

  linkClick(event) {
    if (event.column.columnDef == "createdBy") {
      this.userDetailsRfid(event.row);
    }
    else if (event.column.columnDef == "idTag") {
      this.rfidDetails(event.row);
    }
  }

  buttonClick(result: string[]) {
    if (result[0] == 'delete') {
      let item = this.rfidConsolidatedList.filter(res => res.rfidTag == result[1])
      this.deleteRfid(item[0])
    } else if ((result[0] == 'edit')) {
      let item = this.rfidConsolidatedList.filter(res => res.rfidTag == result[1])
      this.editAssignedRfid(item[0]);
    } else if ((result[0] == 'block')) {
      let item = this.rfidConsolidatedList.filter(res => res.rfidTag == result[1])
      this.assignRfid(item[0]);
    } else if ((result[0] == 'assign')) {
      let item = this.rfidConsolidatedList.filter(res => res.rfidTag == result[1])
      this.reactivateRFID(item[0]);
    }
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.getRFIDs(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.getRFIDs(this.pageList, '');
  }

  applyFilter(filteredData: string) {
    this.getRFIDs(this.pageList, filteredData);
  }

  actionFeature(event) {
    this.router.navigate(['/dashboard/rfid/create', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.RFID_CREATE);
  }

  actionClick(event) {
    this.getRFIDs(this.pageList, '');
  }

  deleteFeature(): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('rfid.deleteTitle') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deleteRfidById();
      }
    });
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  routeBack() {
    this.router.navigate(['/dashboard/rfid', { routeID: this.route.snapshot.paramMap.get('routeID') }])
  }

  reactivateRFID(id) {
    const rejectedid = id.id_tag
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('rfid.reactivate_rfid'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('rfid.reactivate_message') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.changeRejectedStatus(rejectedid)
        this.assignRfid(id)
      }
    });
  }

  changeRejectedStatus(id) {
    const encodedId = this.authenticationService.convertToBase64(id)
    const input = {
      'RFID_TAG': id
    }
    this.rfidService.changeRejectedStatus(encodedId, input).subscribe(((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('wallets.walletSuccess'))
      } else {
        this.toastr.error(this.translate.instant('responseFailed'))
      }
    }), err => {
      this.toastr.error(err.message);
    })
  }
}

export interface RFIDConsolidatedList {
  rfidTag: string;
  createdBy: string;
  status: string;
  role: string;
  disableEdit: boolean;
  disableDelete: boolean;
  disableAssign: boolean;
  checkStatusRejected: boolean;
}

